import React from "react";
import Parser from "html-react-parser";
import icon2 from "../../img/icon2.png";
import { FaCaretDown } from "react-icons/fa"
import Loading from "../../components/loading";
import MaskedInput from 'react-maskedinput';
import ConfigurationService from "../../services/configuration-service";
import CouponBuilderService from "../../services/coupon-builder";
import { IBenefitResponse } from "../../interfaces/benefit";
import { ICouponRequest, ICouponResponse } from "../../interfaces/coupon";
import { CSVLink } from "react-csv";

export default class CouponBuilder extends React.Component<{ history: any }> {
    state = {
        benefits: [] as IBenefitResponse[],
        benefitId: "0" as string,
        quantity: 0 as number,
        dataVencimento: "" as string,
        representative: 0 as number,
        error: "" as string,
        success: false,
        isLoading: false,
        buildingCoupons: false,
        responseCoupon: [] as ICouponResponse[]
    };

    async componentDidMount() {
        this.setState({ isLoading: true });
        this.setState({ quantity: "" });
        this.setState({ representative: "" });
        var response = await CouponBuilderService.getBenefits();

        if (response) {
            this.setState({ benefits: response.data })
            this.setState({ isLoading: false });
        }
    }

    onChangeProduto = async (e: any) => {
        this.clearValues(e);
        this.setState({ benefitId: e.target.value })
    }
    clearValues = async (e: any) => {

        this.setState({ quantity: "" });
        this.setState({ representative: "" });
        this.setState({ error: "" });
        this.setState({ dataVencimento: "" });
        this.setState({ success: false });
    }

    handleChangeDataVencimento = (e: any) => {

        const dataVencimento = e.target.value;
        if (!dataVencimento) this.setState({ dataVencimento, error: "" });

        const data = dataVencimento.split("/");
        const dataFormatada = new Date(`${data[2]}-${data[1]}-${data[0]}`);


        if (isNaN(dataFormatada.getTime())) {
            this.setState({ dataVencimento, error: "Data inválida!" });
        } else {

            const dataAtual = new Date();
            if (dataFormatada <= dataAtual) {
                this.setState({ dataVencimento, error: "A data de vencimento deve ser maior que a data atual!" });
            } else {

                this.setState({ dataVencimento, error: "" });
            }
        }
    };

    handleBuildCoupons = async (e: any) => {
        e.preventDefault();

        var representativeValue = 0;
        if (this.state.benefitId === "54121" || this.state.benefitId === "64741") {
            representativeValue = this.state.representative;
        }

        this.setState({ error: "" });
        if (this.state.benefitId === "0") {
            this.setState({ error: "Escolha um benefício!" });
        }
        else {

            try {
                let dataVencimento;
                if (this.state.dataVencimento) {

                    const data = this.state.dataVencimento.split("/");
                    const isValid = new Date(`${data[2]}-${data[1]}-${data[0]}`);

                    if (isNaN(isValid.getTime())) {
                        this.setState({ dataVencimento, error: "Data inválida!" });
                        return;
                    }


                    const dataAtual = new Date();
                    dataAtual.setHours(0, 0, 0, 0);
                    const dataFormatada = new Date(Number(data[2]), Number(data[1]) - 1, Number(data[0]));
                    if (dataFormatada <= dataAtual) {
                        this.setState({ dataVencimento, error: "A data de vencimento deve ser maior que a data atual!" });
                        return;
                    }

                    dataVencimento = new Date(dataFormatada);
                    dataVencimento.setHours(0, 0, 0, 0);
                }
                this.setState({ buildingCoupons: true });


                const couponRequest = {
                    representative: representativeValue,
                    benefitId: this.state.benefitId,
                    quantity: this.state.quantity,
                    dataVencimento: dataVencimento
                } as ICouponRequest;


                var response = await CouponBuilderService.generateCoupons(couponRequest);
                this.setState({ responseCoupon: response.data })

                if (!response.data.error) {
                    this.clearValues(e);
                    this.setState({ benefitId: "0" });
                    this.setState({ buildingCoupons: false });
                    this.setState({ success: true });

                }
                else {
                    this.setState({ error: response.data.error.message });
                    this.setState({ buildingCoupons: false });
                }
            }
            catch (err) {
                this.setState({ error: "Houve um erro na geração dos vouchers." });
                this.setState({ buildingCoupons: false });
            }
        }
    };



    render() {

        const { isLoading } = this.state;
        const { buildingCoupons } = this.state;
        const { responseCoupon } = this.state;

        const headers = [
            { label: "Representante", key: "representative" },
            { label: "Benefício", key: "benefitId" },
            { label: "Cupom", key: "coupom" },
            { label: "DataVencimento", key: "end" }
        ];

        return (

            <div className="header__form">
                <a href="#" className="header__logo-1">
                    <img src={icon2} alt="" />
                </a>
                <div>
                    <p className="p-text">
                        Geração de vouchers MomentaMais
                    </p>
                    <form onSubmit={this.handleBuildCoupons}>
                        <div className="form-group">
                            <select
                                id="benefitId"
                                onChange={this.onChangeProduto}
                                disabled={buildingCoupons || isLoading}
                                defaultValue={this.state.benefitId || "0"}
                                value={this.state.benefitId || "0"}
                            >
                                <option key="0" value="0">Benefício</option>
                                {
                                    this.state.benefits &&
                                    this.state.benefits.map(p =>
                                        <option key={p.benefitId} value={p.benefitId}>
                                            {p.benefit}
                                        </option>)
                                }
                            </select>
                            <span className="arrow-down"><FaCaretDown /></span>
                        </div>
                        <div className="form-group">
                            <input
                                id="quantity"
                                type="number"
                                placeholder="*Qtde"
                                onChange={e => this.setState({ quantity: e.target.value })}
                                disabled={buildingCoupons || isLoading}
                                min="1" max="100000"
                                required
                                value={this.state.quantity}
                            />
                        </div>
                        <div className="form-group">
                            <MaskedInput
                                id="dataVencimento"
                                type="text"
                                mask="11/11/1111"
                                placeholderChar=" "
                                placeholder="Data de Expiração"
                                onChange={this.handleChangeDataVencimento}
                                disabled={buildingCoupons || isLoading}
                                value={this.state.dataVencimento}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                id="representative"
                                type="number"
                                placeholder="*Representante"
                                onChange={e => this.setState({ representative: e.target.value })}
                                disabled={!(this.state.benefitId === "54121" || this.state.benefitId === "64741" || buildingCoupons || isLoading)}
                                min="10" max="99"
                                required
                                value={this.state.representative}
                            />
                        </div>
                        <div className="form-sc">
                            <div className="form-button">
                                <button
                                    id="submitButton"
                                    type="submit"
                                    className="btn-primary"
                                    disabled={buildingCoupons || isLoading}
                                >
                                    {buildingCoupons ? "Gerando vouchers..." : "Gerar"}
                                </button>
                            </div>

                            <div className="form-group form-message">
                                {this.state.error &&
                                    <div className="text-danger">
                                        {Parser(this.state.error)}
                                    </div>
                                }
                           

                            {this.state.success &&
                                <div className="h4 text-success">
                                    Vouchers gerados com sucesso! <br />
                                    <CSVLink data={responseCoupon} headers={headers} target="_blank" filename="vouchers.csv">Exportar para o Excel</CSVLink>
                                </div>
                            }
                             </div>
                        </div>
                    </form>
                </div>
                <Loading show={buildingCoupons || isLoading} />
            </div>
        );
    }
}